import React from "react";
import { Building2, MapPin, Phone, Mail, Hash, MessageSquare, BadgeCheck, BadgeX } from "lucide-react";
import "./CompanyUnitsTab.scss";

const textOrDash = (value) => {
  if (value === null || value === undefined || value === "") return "-";
  return String(value);
};

export default function CompanyUnitsTab({ units }) {
  const list = Array.isArray(units) ? units : [];

  return (
    <div className="company-units-tab">
      <div className="company-units-tab__header">
        <h2 className="company-units-tab__title">
          <Building2 className="company-units-tab__title-icon" />
          Njesite Organizative
        </h2>
        <p className="company-units-tab__subtitle">
          Pasqyre e njesive organizative te regjistruara per kete kompani.
        </p>
      </div>

      <div className="company-units-tab__grid">
        {list.map((unit) => {
          const isActive = !!unit.IsActive;

          return (
            <article key={unit.UnitID} className="company-units-tab__card">
              <div className="company-units-tab__card-top">
                <div className="company-units-tab__name-wrap">
                  <h3 className="company-units-tab__name">{textOrDash(unit.UnitName)}</h3>
                  <p className="company-units-tab__unit-id">ID: {textOrDash(unit.UnitID)}</p>
                </div>
                <span className={`company-units-tab__status ${isActive ? "is-active" : "is-inactive"}`}>
                  {isActive ? (
                    <>
                      <BadgeCheck className="company-units-tab__status-icon" />
                      Aktive
                    </>
                  ) : (
                    <>
                      <BadgeX className="company-units-tab__status-icon" />
                      Jo aktive
                    </>
                  )}
                </span>
              </div>

              <div className="company-units-tab__details">
                <div className="company-units-tab__detail-item">
                  <Hash className="company-units-tab__detail-icon" />
                  <span>{textOrDash(unit.IdentificationNumber)}</span>
                </div>
                <div className="company-units-tab__detail-item">
                  <MapPin className="company-units-tab__detail-icon" />
                  <span>{textOrDash(unit.UnitAdress)}</span>
                </div>
                <div className="company-units-tab__detail-item">
                  <Phone className="company-units-tab__detail-icon" />
                  <span>{textOrDash(unit.PhoneNumbers)}</span>
                </div>
                <div className="company-units-tab__detail-item">
                  <Mail className="company-units-tab__detail-icon" />
                  <span>{textOrDash(unit.Email)}</span>
                </div>
                <div className="company-units-tab__detail-item company-units-tab__detail-item--full">
                  <MessageSquare className="company-units-tab__detail-icon" />
                  <span>{textOrDash(unit.Comment)}</span>
                </div>
              </div>
            </article>
          );
        })}
      </div>
    </div>
  );
}
